import axios from "axios";

export function AxiosRequest(url, body, requestOptions) {
    return axios.post(url, body, requestOptions);
}

export function BuildAxiosRequestHeaders(method, endpoint) {
    var myHeaders = {
        headers: {
            Method: method,
            Endpoint: endpoint,
            "Content-Type": "application/json",
        },
    };

    return myHeaders;
}

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("access_token");
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
            config.headers["IdToken"] = "public";
        }
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const originalRequest = error.config;
        console.log(error);
        if (error.response.status === 401 || !originalRequest._retry) {
            localStorage.removeItem("access_token")
            localStorage.removeItem("refresh_token")
            localStorage.removeItem("expires_in")
            localStorage.removeItem("id_token")

            originalRequest._retry = true;
            return axios
                .get("https://ochad.connecthealthworks.co.uk/api/public", {
                    headers: {
                        appname: "PatientPortal",
                    },
                })
                .then((res) => {
                    if (res.status === 200) {
                        // console.log(res.data);
                        localStorage.setItem("access_token", res.data.access_token);
                        localStorage.setItem("refresh_token", res.data.refresh_token);
                        localStorage.setItem("expires_in", res.data.expires_in);
                        localStorage.setItem("id_token", "public");
                    }
                    axios.defaults.headers.common["Authorization"] =
                        "Bearer " + localStorage.getItem("access_token");

                    return axios(originalRequest);
                });
            
        }
        return Promise.reject(error);
    }
);
